/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = {
  agency: 'agency',
  agencyName: 'agencyName',
  agencyNumber: 'agencyNumber',
  street: 'street',
  postalCode: 'postalCode',
  city: 'city',
  country: 'country',
  agencyInfo: 'agencyInfo',
  agencyAddress: 'agencyAddress',
  agent: 'agent',
  information: 'information',
  contact: 'contact',
  firstName: 'firstName',
  lastName: 'lastName',
  userName: 'userName',
  agencyOwner: 'agencyOwner',
  consumer: 'consumer',
  phone: 'phone',
  customer: 'customer',
  preferences: 'preferences',
  password: 'password'
}; export default Keys;